export const ERROR_EMBED_CONTEXT_INVALID_RECEIVE_MESSAGE = 'ERROR_EMBED_CONTEXT_INVALID_RECEIVE_MESSAGE';
export const ERROR_EMBED_NOT_READY = 'ERROR_EMBED_NOT_READY';
export const ERROR_UNABLE_TO_SYNC = 'ERROR_UNABLE_TO_SYNC';
export const ERROR_INVALID_CALLBACK_PROVIDED = 'ERROR_INVALID_CALLBACK_PROVIDED';